
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 62 47","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.351 23.264h45.433","fill":"none","stroke":"currentColor","stroke-width":"3.57"}}),_c('path',{attrs:{"d":"M38.644 7.384l15.74 15.881-15.74 15.881","fill":"none","stroke":"currentColor","stroke-width":"3.58"}})])
          )
        }
      }
    